// extracted by mini-css-extract-plugin
module.exports = {"root":"quoted-tweet-container_root__XCwvy","article":"quoted-tweet-container_article__MT9wH"};